import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '../../../utils';
import { UserPlus } from 'lucide-react';

export default function DebtorListHeader() {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Data Debitur</h1>
        <p className="text-gray-500 mt-1">Kelola seluruh data nasabah/debitur</p>
      </div>
      <Link to={createPageUrl('DebtorForm')}>
        <button className="bg-amber-600 hover:bg-amber-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors">
          <UserPlus className="w-4 h-4" />
          Tambah Debitur
        </button>
      </Link>
    </div>
  );
}
